import { BasicSearchCriteria } from "./BasicSearchCriteria";
import { ImageCopyright } from "./ImageCopyright";
import { ImageReference } from "./ImageReference";
import { ImageType } from "./ImageType";
import { PlantDataSource } from "./PlantDataSource";
import { PlantDuration } from "./PlantDuration";
import { PlantGroup } from "./PlantGroup";
import { PlantGrowthHabit } from "./PlantGrowthHabit";
import { PlantLocation } from "./PlantLocation";
import { SearchFilteringOption } from "./SearchFilteringOption";
import { WetlandRegion } from "./WetlandRegion";

export class SearchCriteria {
  public Text: string;
  public Field: string;
  public Locations: PlantLocation[];
  public Groups: PlantGroup[];
  public Durations: PlantDuration[];
  public GrowthHabits: PlantGrowthHabit[];
  public WetlandRegions: WetlandRegion[];
  public NoxiousLocations: PlantLocation[];
  public InvasiveLocations: PlantLocation[];
  public Countries: PlantLocation[];
  public Provinces: PlantLocation[];
  public Counties: PlantLocation[];
  public Cities: PlantLocation[];
  public Localities: PlantLocation[];
  public ArtistFirstLetters: string[];
  public ImageLocations: PlantLocation[];
  public Artists: PlantDataSource[];
  public CopyrightStatuses: ImageCopyright[];
  public ImageReferences: ImageReference[];
  public ImageTypes: ImageType[];
  public SortBy: string;
  public Offset: number;
  public FilterOptions: SearchFilteringOption[];
  public UnfilteredPlantIds: number[];
  public Type: string;
  public TaxonSearchCriteria: BasicSearchCriteria;
  public MasterId: number;

  constructor(
    Text: string,
    Field: string,
    Locations: PlantLocation[],
    Groups: PlantGroup[],
    Durations: PlantDuration[],
    GrowthHabits: PlantGrowthHabit[],
    WetlandRegions: WetlandRegion[],
    NoxiousLocations: PlantLocation[],
    InvasiveLocations: PlantLocation[],
    Countries: PlantLocation[],
    Provinces: PlantLocation[],
    Counties: PlantLocation[],
    Cities: PlantLocation[],
    Localities: PlantLocation[],
    ArtistFirstLetters: string[],
    ImageLocations: PlantLocation[],
    Artists: PlantDataSource[],
    CopyrightStatuses: ImageCopyright[],
    ImageReferences: ImageReference[],
    ImageTypes: ImageType[],
    SortBy: string,
    Offset: number,
    FilterOptions: SearchFilteringOption[],
    UnfilteredPlantIds: number[],
    Type: string,
    TaxonSearchCriteria: BasicSearchCriteria,
    MasterId: number
  ) {
    this.Text = Text;
    this.Field = Field;
    this.Locations = Locations;
    this.Groups = Groups;
    this.Durations = Durations;
    this.GrowthHabits = GrowthHabits;
    this.WetlandRegions = WetlandRegions;
    this.NoxiousLocations = NoxiousLocations;
    this.InvasiveLocations = InvasiveLocations;
    this.Countries = Countries;
    this.Provinces = Provinces;
    this.Counties = Counties;
    this.Cities = Cities;
    this.Localities = Localities;
    this.ArtistFirstLetters = ArtistFirstLetters;
    this.ImageLocations = ImageLocations;
    this.Artists = Artists;
    this.CopyrightStatuses = CopyrightStatuses;
    this.ImageReferences = ImageReferences;
    this.ImageTypes = ImageTypes;
    this.SortBy = SortBy;
    this.Offset = Offset;
    this.FilterOptions = FilterOptions;
    this.UnfilteredPlantIds = UnfilteredPlantIds;
    this.Type = Type;
    this.TaxonSearchCriteria = TaxonSearchCriteria;
    this.MasterId = MasterId;
  }
}
